module.exports = __webpack_public_path__ + "media/media/distributors/five_years-d9f199f7e0e69a2dd3844b51f8e3204e.png";